module.exports = __webpack_public_path__ + "static/img/girl-camera.0b5a31d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/girl-camera.jpg
// module id = K38c
// module chunks = 1